const HOME_DATA_TIMEOUT_MS = 8_000;

function createTimeoutError() {
  const error = new Error('Home data refresh timed out.');
  error.code = 'home_data_timeout';
  return error;
}

function withHomeDataTimeout(promise, timeoutMs = HOME_DATA_TIMEOUT_MS) {
  let timer;
  return Promise.race([
    Promise.resolve(promise),
    new Promise((_, reject) => {
      timer = setTimeout(() => reject(createTimeoutError()), timeoutMs);
    }),
  ]).finally(() => clearTimeout(timer));
}

function classifyHomeDataError(error, online = (
  typeof navigator === 'undefined' ? true : navigator.onLine !== false
)) {
  if (!online) return 'offline';
  if (error?.code === 'home_data_timeout') return 'timeout';
  return 'error';
}

function buildHomeDataState({
  challengeStatus,
  hasSnapshot,
  historyStatus,
  retry,
}) {
  const statuses = [challengeStatus, historyStatus];
  let status = 'loading';

  if (statuses.every(candidate => candidate === 'ready')) {
    status = 'ready';
  } else if (statuses.includes('offline')) {
    status = 'offline';
  } else if (statuses.includes('timeout')) {
    status = 'timeout';
  } else if (statuses.includes('error')) {
    status = 'error';
  } else if (statuses.every(candidate => candidate === 'cached')) {
    status = 'cached';
  } else if (hasSnapshot) {
    status = 'refreshing';
  }

  return {
    hasSnapshot: Boolean(hasSnapshot),
    retry,
    source: hasSnapshot ? 'cache' : 'network',
    status,
  };
}

export {
  HOME_DATA_TIMEOUT_MS,
  buildHomeDataState,
  classifyHomeDataError,
  withHomeDataTimeout,
};
